import logoWhite from "./logo-white.png";
import logo from "./logo.png";
// import powered from "./powered.png";
// import poweredColor from "./powered-color.png";
// import mapIndo from "./map-indo.png";
// import bgBlur from "./bg-blur.png";
// import bgSandiaga from "./bg-sandiaga.png";
import bgRight from "./bg-right.png";
// import bgLeft from "./bg-left.png";
// import founder from "./founder.png";
// import kurikulumGrowth from "./kurikulum-growth.png";

import newBanner from "./new-design/banner.png";
import newCircle from "./new-design/cicrcle.png";
import newFounder from "./new-design/founder.png";

import newMap from "./new-design/map.png";
import newMale from "./new-design/female.png";
import newMaleFemale from "./new-design/male-femail.png";
import newTimeLineCreate from "./new-design/time-line-create.png";
import newTimeLineAcelerate from "./new-design/time-line-acelerate.png";
import newInvinitee from "./new-design/invitinte.png";
import newArticle1 from "./article-1.png";
import newArticle2 from "./article-2.png";


import newCreate from "./new-design/create.png";
import newAcelerate from "./new-design/accelerate.png";
import newCriteria from "./new-design/criteria.png";

import newProgram01 from "./new-design/programs/01.png";
import newProgram02 from "./new-design/programs/02.png";
import newProgram03 from "./new-design/programs/03.png";

const newGalleryMap = import.meta.glob("./new-design/gallery/galery-*.png", { eager: true });
const newGallery = Object.entries(Object.values(newGalleryMap))
  .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
  .map(([, mod]) => (mod as any).default);

// const parnersMap = import.meta.glob("./partner-*.png", { eager: true });
// const incubatorMap = import.meta.glob("./incubator-*.png", { eager: true });
// const timelineMap = import.meta.glob("./time-line-*.png", { eager: true });

// const parners = Object.entries(Object.values(parnersMap))
//   .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
//   .map(([, mod]) => (mod as any).default);
// const incubator = Object.entries(Object.values(incubatorMap))
//   .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
//   .map(([, mod]) => (mod as any).default);

// const timeline = Object.entries(Object.values(timelineMap))
//   .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
//   .map(([, mod]) => (mod as any).default);

export const Images = {
  logoWhite,
  logo,
  // powered,
  // poweredColor,
  // mapIndo,
  // parners,
  // incubator,
  // bgBlur,
  // bgSandiaga,
  bgRight,
  // bgLeft,
  // founder,
  // kurikulumGrowth,
  // timeline,
  design: {
    banner: newBanner,
    circle: newCircle,
    founder: newFounder,
    location: newMap,
    male: newMale,
    maleFemale: newMaleFemale,
    timeLineCreate: newTimeLineCreate,
    invinitee: newInvinitee,
    create: newCreate,
    acelerate: newAcelerate,
    timeLineAcelerate: newTimeLineAcelerate,
    gallery: newGallery,
    criteria: newCriteria,
    article1: newArticle1,
    article2: newArticle2,
    program: {
      program01: newProgram01,
      program02: newProgram02,
      program03: newProgram03,
    },
  },
};
